const mdata = [
    {
        mname : "Shadow Hunters",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BNTU1N2ViZDctYzQwOS00ZDYyLThkMDItNmEwYTIyZTI4NGFhXkEyXkFqcGdeQXVyNTM1NDMwNDM@._V1_.jpg",
        mheading : "Netflix Original Series",
        mlink : "https://www.netflix.com/shadowhunters"
    },
    {
        mname : "Dark",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BOTk2NzUyOTctZDdlMS00MDJlLTgzNTEtNzQzYjFhNjA0YjBjXkEyXkFqcGdeQXVyMjg1NDcxNDE@._V1_FMjpg_UX1000_.jpg",
        mheading : "Netflix Original Series",
        mlink : "https://www.netflix.com/dark"
    },  
    {
        mname : "Sex Education",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BODhmN2Q4ZjUtNzE5Ni00YWQxLThmYjYtM2NkNDEwNmFhMGY3XkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_FMjpg_UX1000_.jpg",
        mheading : "Netflix Original Series",
        mlink : "https://www.netflix.com/sexeducation"
    },
    {
        mname : "Vampires",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BZDJhNjA5YTAtMTNhYy00YWYyLWE0OTYtMWQwZmYyMDM5ZGIyXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg",
        mheading :" Netflix Original Series",
        mlink : "https://www.netflix.com/vampires"
    },
    {
        mname : "Stranger Things",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BN2ZmYjg1YmItNWQ4OC00YWM0LWE0ZDktYThjOTZiZjhhN2Q2XkEyXkFqcGdeQXVyNjgxNTQ3Mjk@._V1_.jpg",
        mheading :" Netflix Original Series",
        mlink : "https://www.netflix.com/strangerthings"
    },
    {
        mname : "Sex Education",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BODhmN2Q4ZjUtNzE5Ni00YWQxLThmYjYtM2NkNDEwNmFhMGY3XkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_FMjpg_UX1000_.jpg",
        mheading : "Netflix Original Series",
        mlink : "https://www.netflix.com/sexeducation"
    },
    {
        mname : "Vampires",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BZDJhNjA5YTAtMTNhYy00YWYyLWE0OTYtMWQwZmYyMDM5ZGIyXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg",
        mheading :" Netflix Original Series",
        mlink : "https://www.netflix.com/vampires"
    },
    {
        mname : "Stranger Things",
        mimgsrc : "https://m.media-amazon.com/images/M/MV5BN2ZmYjg1YmItNWQ4OC00YWM0LWE0ZDktYThjOTZiZjhhN2Q2XkEyXkFqcGdeQXVyNjgxNTQ3Mjk@._V1_.jpg",
        mheading :" Netflix Original Series",
        mlink : "https://www.netflix.com/strangerthings"
    }
];

export default mdata;